import script from "./CaptchaClickDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./CaptchaClickDialog.vue?vue&type=script&setup=true&lang=js"

import "./CaptchaClickDialog.vue?vue&type=style&index=0&id=28bd346e&scoped=true&lang=css"

import exportComponent from "D:\\cwzl\\four-cw-net\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28bd346e"]])

export default __exports__